<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    :style="{ opacity }">
    <path
      d="M8.97394 3.3732C9.31943 2.16468 11.0324 2.16468 11.3779 3.3732L12.4147 7.00357C12.521 7.37527 12.7939 7.67705 13.1528 7.82063L15.7 8.83951C16.7477 9.25858 16.7477 10.7414 15.7 11.1605L13.1528 12.1802C12.7938 12.3238 12.5209 12.6254 12.4147 12.9972L11.3779 16.6268C11.0325 17.8355 9.31934 17.8355 8.97394 16.6268L7.93716 12.9972C7.83092 12.6254 7.5581 12.3238 7.19904 12.1802L4.65184 11.1605C3.60415 10.7414 3.60415 9.25858 4.65184 8.83951L7.19904 7.82063C7.558 7.67705 7.83085 7.37527 7.93716 7.00357L8.97394 3.3732Z"
      :fill="color" />
  </svg>
</template>

<script>
export default {
  name: "StarIcon",
  props: {
    size: { type: [Number, String], default: 24 },
    color: { type: String, default: "#9720EB" },
    opacity: { type: [Number, String], default: 1 },
  },
};
</script>
